export enum ElementType 
{
    HEADING,
    PARAGRAPH,
    CHECKBOX,
    PASSWORD,
    TEXTBOX,
    RADIO,
    LIST_ITEM,
    DROPDOWN,
    IMAGE,
    FILEUPLOAD,
    BUTTON,
    RADIO_QUESTION,
    LIST_QUESTION,
    TEXT_QUESTION,
    MENU_QUESTION,
    YES_NO_QUESTION,
    GENERICFIELD,
    TAB_ACCORDION,
    REPORT,
    RENDER,
    TRACKING,
    SECTION,
    BABYSTATUSCONDITIONS,
    QUERYBUILDER,
    MAP,
    CARD,
    ATTACHMENTS,
    GRAPH,
    Table,
    
    //CAPTCHA,
}

